export enum HotKey {
    SELECT_SITE = 'SELECT_SITE',
    UNIVERSAL_SEARCH = 'UNIVERSAL_SEARCH',
    CANCEL = 'CANCEL',
}

export const GLOBAL_HOT_KEYS = {
    [HotKey.SELECT_SITE]: '/',
    [HotKey.UNIVERSAL_SEARCH]: 'shift+/',
    [HotKey.CANCEL]: 'escape',
};

type HotKeyMap = {
    [key: string]: string | string[];
};

const createKeyMap = (...hotKeys: HotKey[]) => {
    const keyMap = {} as HotKeyMap;
    hotKeys.forEach(action => (keyMap[action] = GLOBAL_HOT_KEYS[action]));
    return keyMap;
};

export default createKeyMap;
